import React from 'react';
import { TxCountChangedStore } from '../../../stores/ChangeNotificationsStore';

export default function Provider({ children }) {
  return <TxCountChangedStore.Provider>{children}</TxCountChangedStore.Provider>;
}
